export class AddStairsAction {
  constructor(
    public readonly superStructureId: number
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/AddStairsAction.ts